@if (orderSupportDetails?.errorOrders || orderSupportDetails?.warningOrders || orderSupportDetails?.heldOrders) {
  <div  class="quickFiltersLayout">
    @if (orderSupportDetails?.errorOrders) {
      <div  tooltip [tooltipTitle]='errorOrdersToolTip'
        [tooltipWidth]='243'
        [class]="orderSupportDetails?.errorOrders?'quicklinkstyle':''"
        [tooltipVerticalOffset] = '8' [tooltipHorizontalOffset] = '8'
        (click)="filterErrorOrders()" class="quick-filter-list quick-filter-list1">
        <img  class="quick-icons" src="../../assets/images/exclamation-circle.png" >Error Orders ({{orderSupportDetails?.errorOrders}})</div>
      }
      @if (orderSupportDetails?.warningOrders) {
        <div tooltip [tooltipTitle]='warningOrdersToolTip'
          [tooltipVerticalOffset] = '8' [tooltipHorizontalOffset] = '8' [tooltipWidth]='243'
          [class]="orderSupportDetails?.warningOrders?'quicklinkstyle orderWarning':''"
          (click)="filterWarningOrders()" class="quick-filter-list">
          <img class="quick-icons" src="../../assets/images/exclamation-triangle.png">Warning Orders ({{orderSupportDetails?.warningOrders}})</div>
        }
        @if (orderSupportDetails?.heldOrders) {
          <div tooltip [tooltipTitle]='heldOrdersToolTip'
            [tooltipVerticalOffset] = '8' [tooltipHorizontalOffset] = '8' [tooltipWidth]='243'
            [class]="orderSupportDetails?.heldOrders?'quicklinkstyle':''"
            (click)="filterHeldOrders()" class="quick-filter-list warning">
            <img class="quick-icons" src="../../assets/images/exclamation-triangle.png">On Hold Orders ({{orderSupportDetails?.heldOrders}})</div>
          }
        </div>
      }
